export const ANSWER_GRID_VISIBLE_USERS_COUNT = 6;

export const getColumnSizes = ({ columns }) =>
  `199px repeat(${columns.length - 1}, minmax(250px, 1fr))`;
